import { render, staticRenderFns } from "./r-product-status.vue?vue&type=template&id=1d132186"
import script from "./r-product-status.vue?vue&type=script&lang=js"
export * from "./r-product-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d132186')) {
      api.createRecord('1d132186', component.options)
    } else {
      api.reload('1d132186', component.options)
    }
    module.hot.accept("./r-product-status.vue?vue&type=template&id=1d132186", function () {
      api.rerender('1d132186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/product/r-product-status.vue"
export default component.exports